module.exports = __webpack_public_path__ + "assets/link_copy.7a84695516c607bdd03a2b5a487b8a82.svg";